function getCSRFToken() {
  const csrfTag = document.querySelector(
    "meta[name='csrf-token']"
  ) as HTMLMetaElement;

  if (!csrfTag) return;

  return csrfTag.content;
}

function throttle(callbackFn, limit: number) {
  let wait = false;
  return function () {
    if (!wait) {
      callbackFn();
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

export { getCSRFToken };
export { throttle };
